<script>
export default {
  name: 'UsedBrands',
  props: {
    data: {
      type: Object,
    },
    url: {
      type: String,
    },
  },
  data() {
    return {
      first: this.data.brands,
      second: this.data.brands.slice(8),
      isHidden: false,
      width: window.innerWidth,
    };
  },
  methods: {
    showMore() {
      this.isHidden = !this.isHidden;
    },
    getBrandOrder() {
      if (this.width < 350) {
        return 5;
      } else if (this.width < 450) {
        return 8;
      } else if (this.width < 530) {
        return 15;
      } else if (this.width < 1600) {
        return 10;
      } else return 13;
    },
  },
};
</script>
<template>
  <div class="container">
    <div class="flex flex-row w-full gap-[20px] mb-[20px] flex-wrap">
      <a
        v-for="(brand, index) in first"
        :href="url + brand.url + '/'"
        class="flex w-fit items-baseline"
        :class="{ '!hidden': index > getBrandOrder() }"
        :data-used-brand="index > getBrandOrder() ? true : null"
      >
        <div class="flex text-sm font-medium font-fira w-fit">
          {{ brand.name }}
        </div>
        <div
          class="px-2 ml-1 text-sm font-medium leading-5 text-white rounded-brand bg-green"
        >
          {{ brand.count }}
        </div>
      </a>
      <div
        class="px-2 text-sm font-medium leading-5 rounded-brand bg-gray-200 showmore"
        data-toggle="[data-used-brand]"
        v-if="!isHidden && data.brands.length > getBrandOrder()"
        @click="showMore"
      >
        ...
      </div>
      <div
        data-toggle="[data-used-brand]"
        @click="showMore"
        v-if="isHidden"
        class="w-full cursor-pointer flex flex-row gap-[10px] text-base font-medium hideBtn justify-center"
      >
        Свернуть<img
          src="/public/images/svg/arrow-down.svg"
          width="18"
          height="18"
          alt="arrowUp"
          class="rotate-180"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
.custom {
  border-bottom: 1px dashed #bababa;
}
.showmore {
  border: 1px solid black;
  cursor: pointer;
}
.hideBtn {
  padding-top: 12px;
  border-top: 1px solid black;
  margin-top: 20px;
}
</style>
